module.exports = __webpack_public_path__ + "img/icon-plus.718b7a63.svg";